import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import styled from "styled-components";

const PrimaryTabs = ({ tabsInfo }) => {
  const tabList = tabsInfo.map(({ text }) => text);
  const tabPanelList = tabsInfo.map(({ TapPanelContent }) => TapPanelContent);
  console.log(tabPanelList);
  return (
    <Tabs>
      <div className="flex justify-center">
        <StyledTabList
          className={
            "flex rounded-full w-fit justify-center basis-auto gap-x-3 bg-secondary-600 p-[6px] text-sm font-semibold my-5"
          }
        >
          {tabList.map((tab, index) => {
            return (
              <Tab
                key={index}
                className="py-3 px-[27px] rounded-full cursor-pointer min-w-[120px] flex justify-center items-center transition-all duration-300 hover:bg-white"
              >
                {tab}
              </Tab>
            );
          })}
        </StyledTabList>
      </div>

      {tabPanelList.map((Panel, index) => {
        return (
          <TabPanel key={index}>
            <Panel />
          </TabPanel>
        );
      })}
    </Tabs>
  );
};

const StyledTabList = styled(TabList)`
  .react-tabs__tab--selected {
    background-color: white;
  }
`;

export default PrimaryTabs;
